export enum StartingPosition {
  SIT = 'SIT' /** t(SIT) **/,
  STAND = 'STAND' /** t(STAND) **/,
  CROUCH = 'CROUCH' /** t(CROUCH) **/,
  FRENCH = 'FRENCH' /** t(FRENCH) **/,
  CANDLE = 'CANDLE' /** t(CANDLE) **/,
  LAYDOWN = 'LAYDOWN' /** t(LAYDOWN) **/,
}
